import React from 'react';

import * as styles from './styles';
import { TableCell as BaseTableCell, TableHead as BaseTableHead, TableRow as BaseTableRow, withStyles } from '@material-ui/core';

import type { SortOrder } from '@cobliteam/common-types';

import { HintPopup } from '../../HintPopup/HintPopup';
import { Checkbox } from '../../SelectionControls';
import { applyCustomStyles } from '../../styles';
import { TableSortLabel } from '../TableSortLabel/TableSortLabel';
import type { ITableColumn, ITableRow, SelectionConfig } from '../Types';

export interface TableHeadProps<T extends ITableRow> {
  onRequestSort?: (property: ITableColumn<T>) => void;
  onSelectAllClick?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  order?: SortOrder;
  orderBy?: ITableColumn<T>;
  numSelected?: number;
  rowCount?: number;
  columns: Array<ITableColumn<T>>;
  selectionConfig?: SelectionConfig;
  editable?: boolean;
  expandable?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const TableHeadCell = withStyles(styles.headCell)(BaseTableCell);
const TableHeadRow = withStyles(styles.headRow)(BaseTableRow);

const TableHintPopup = applyCustomStyles(HintPopup);

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export class TableHead<T extends ITableRow> extends React.Component<TableHeadProps<T>> {
  private createSortHandler = (property: ITableColumn<T>) => () => {
    const { onRequestSort } = this.props;
    return onRequestSort ? onRequestSort(property) : () => {};
  };

  private labelComponent = (column: ITableColumn<T>) => {
    const { order, orderBy } = this.props;

    return (
      <TableSortLabel active={column === orderBy} sortable={column.sortable} direction={order} onClick={this.createSortHandler(column)}>
        {column.label}
      </TableSortLabel>
    );
  };

  private getHintPlacement = (numColumns: number, idx: number) => {
    if (idx === numColumns - 1) {
      return 'bottom-end';
    }
    if (idx === 0) {
      return 'bottom-start';
    }
    return 'bottom';
  };

  public render() {
    const { columns, expandable, editable, numSelected, rowCount, orderBy, order, selectionConfig, onSelectAllClick } = this.props;

    return (
      <BaseTableHead>
        <TableHeadRow>
          {selectionConfig && (
            <TableHeadCell className={selectionConfig.className || ''}>
              {selectionConfig.selectable && (
                <Checkbox
                  indeterminate={numSelected && rowCount ? numSelected > 0 && numSelected < rowCount : undefined}
                  checked={rowCount !== 0 && numSelected === rowCount}
                  onChange={onSelectAllClick}
                  disabled={rowCount === 0}
                />
              )}
            </TableHeadCell>
          )}
          {columns.map((column, idx) => {
            if (column.hide) {
              return null;
            }
            return (
              <TableHeadCell key={column.id} className={column.className} align={column.align} sortDirection={orderBy === column ? order : false}>
                {column.hint ? (
                  <TableHintPopup
                    title={column.hint}
                    placement={this.getHintPlacement(columns.length, idx)}
                    customStyles={styles.hintStyles}
                    disableFocusListener
                    disableTouchListener
                    arrow
                  >
                    {this.labelComponent(column)}
                  </TableHintPopup>
                ) : (
                  this.labelComponent(column)
                )}

                {column.Tooltip && (
                  <span className={styles.tooltip}>
                    <column.Tooltip />
                  </span>
                )}
              </TableHeadCell>
            );
          })}
          {expandable && <TableHeadCell style={{ width: '60px' }} />}
          {editable && <TableHeadCell />}
        </TableHeadRow>
      </BaseTableHead>
    );
  }
}
